export enum AppViewMode {
  Onggoing = "ONGGOING",
  Hyundai = "HYUNDAI",
}
